import { Icon, Menu } from '@atom/mui';
import { CreateIcon, DeleteIcon } from '@atom/mui/icons';
import { WorkOrderField } from '@atom/types/work';

const { MenuItem } = Menu;

interface Props {
  field: WorkOrderField;
  onEdit: (field: WorkOrderField) => void;
  onDelete: (field: WorkOrderField) => void;
  isWorkTemplate?: boolean;
}

const styles = {
  icon: {
    marginRight: '0.5rem',
  },
};

const WorkOrderFieldMenu = ({
  field,
  onEdit,
  onDelete,
  isWorkTemplate,
}: Props) => {
  const handleEditClick = (selectedField: WorkOrderField) => {
    onEdit(selectedField);
  };

  const handleDeleteClick = (selectedField: WorkOrderField) => {
    onDelete(selectedField);
  };

  return (
    <Menu dataCyLabel={`workOrderFieldMenu-${field.title}`}>
      <MenuItem
        onClick={() => handleEditClick(field)}
        data-cy={`workOrderFieldEdit-${field.title}`}
      >
        <Icon style={styles.icon} icon={CreateIcon} />
        Edit
      </MenuItem>
      {!isWorkTemplate && (
        <MenuItem
          onClick={() => handleDeleteClick(field)}
          data-cy={`workOrderFieldDelete-${field.title}`}
        >
          <Icon style={styles.icon} icon={DeleteIcon} />
          Delete
        </MenuItem>
      )}
    </Menu>
  );
};

export default WorkOrderFieldMenu;
